
















import { defineComponent, computed } from '@vue/composition-api'

import { IMonitor } from '@/types/monitor'

type Props = {
  monitors: IMonitor[]
  total: number
  loading: boolean
}

export default defineComponent({
  name: 'MonitorsTable',
  props: {
    monitors: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props) {
    const headers = [
      { text: 'ID', value: 'id' },
      { text: '性別', value: 'gender' },
      { text: '誕生日', value: 'birthday' },
      { text: '年齢', value: 'age' },
      { text: '郵便番号', value: 'zipcode' },
      { text: '都道府県コード', value: 'prefecture' },
    ]
    const items = computed(() => {
      return props.monitors
    })

    return { headers, items }
  },
})
